import React, { useState, useRef } from 'react'
import { Modal, Form } from 'react-bootstrap'
import { CheckBox } from 'devextreme-react/check-box'
import { toast } from 'react-toastify'
import { useParams } from '../../../Providers/ParamsProvider'

const EMPTY_ELEMENT = { headerId: '', title: '', url: '', isDirect: false }

const AddEditFooterItemModal = ({ show, onHide, onSaved, headers, editItem }) => {
    const { handleAddFooterItem, handleUpdateFooterItem } = useParams()
    const [footerItem, setFooterItem] = useState(EMPTY_ELEMENT)
    const [errorText, setErrorText] = useState(null)
    const [prevShow, setPrevShow] = useState(false)
    const firstInputRef = useRef(null)

    const isEditMode = !!editItem

    if (show !== prevShow) {
        setPrevShow(show)
        if (show) {
            setFooterItem(editItem ? { ...editItem } : EMPTY_ELEMENT)
            setErrorText(null)
        }
    }

    const validateData = () => {
        if (!footerItem.headerId) {
            setErrorText('Wybierz nagłówek!')
            return false
        }
        if (!footerItem.title.trim()) {
            setErrorText('Uzupełnij tytuł!')
            return false
        }
        if (!footerItem.url.trim()) {
            setErrorText('Uzupełnij URL!')
            return false
        }
        return true
    }

    const handleSave = async () => {
        if (!validateData()) {
            return
        }
        const payload = { ...footerItem, headerId: parseInt(footerItem.headerId, 10) }
        const success = isEditMode
            ? await handleUpdateFooterItem(payload)
            : await handleAddFooterItem(payload)

        if (success) {
            toast.success(isEditMode ? 'Zapisano zmiany.' : 'Dodano nową pozycję.')
            setFooterItem(EMPTY_ELEMENT)
            setErrorText(null)
            onSaved?.()
            onHide()
        } else {
            toast.error(isEditMode ? 'Błąd podczas zapisu zmian!' : 'Błąd podczas dodawania pozycji!')
        }
    }

    return (<Modal size='lg' show={show} onHide={onHide} centered onEntered={() => firstInputRef.current?.focus()}>
        <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? 'Edycja pozycji stopki' : 'Dodawanie pozycji stopki'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="row mt-2 align-items-center">
                <div className="col-3"><span>Nagłówek:</span></div>
                <div className="col">
                    <Form.Select
                        ref={firstInputRef}
                        value={footerItem.headerId}
                        onChange={(e) => setFooterItem({ ...footerItem, headerId: e.target.value })}
                    >
                        <option value=''>-- wybierz nagłówek --</option>
                        {headers?.map(header => (
                            <option key={header.headerId} value={header.headerId}>{header.title}</option>
                        ))}
                    </Form.Select>
                </div>
                <div className="col-auto">
                    <span className='error-text-color'>*</span>
                </div>
            </div>
            <div className="row mt-2 align-items-center">
                <div className="col-3"><span>Tytuł:</span></div>
                <div className="col">
                    <Form.Control
                        name='title'
                        value={footerItem.title}
                        maxLength={200}
                        onChange={(e) => setFooterItem({ ...footerItem, title: e.target.value })}
                    />
                </div>
                <div className="col-auto">
                    <span className='error-text-color'>*</span>
                </div>
            </div>
            <div className="row mt-2 align-items-center">
                <div className="col-3"><span>URL:</span></div>
                <div className="col">
                    <Form.Control
                        name='url'
                        value={footerItem.url ?? ''}
                        maxLength={1000}
                        onChange={(e) => setFooterItem({ ...footerItem, url: e.target.value })}
                    />
                </div>
                <div className="col-auto">
                    <span className='error-text-color'>*</span>
                </div>
            </div>
            <div className="row mt-2 align-items-center">
                <div className="col-auto"><span>Wewnątrz platformy E-Handel:</span></div>
                <div className="col">
                    <CheckBox
                        className="custom-checkbox"
                        value={footerItem.isDirect}
                        onValueChanged={(e) => setFooterItem({ ...footerItem, isDirect: e.value })}
                    />
                </div>
            </div>
            <div className={`d-flex justify-content-center mt-3 mb-3`}>
                <span className='error-text-color'>{errorText}</span>
            </div>
            <div className="d-flex flex justify-content-end  mt-4">
                <button className='btn-app-primary me-3' onClick={() => handleSave()}>{isEditMode ? 'Zapisz' : 'Dodaj'}</button>
                <button className='btn-app-secondary' onClick={() => onHide(null)}>Anuluj</button>
            </div>
        </Modal.Body>
    </Modal>)
}

export default AddEditFooterItemModal
